var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254,
    height: 70,
    viewBox: "0 0 254 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4044_29418)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 254,
    height: 70,
    rx: 4,
    fill: "#969592",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 253,
    height: 69,
    rx: 3.5,
    stroke: "#969592",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C1.79086 0 0 1.79086 0 4V29H0.969605L3.73029 7.37467C3.97053 5.49276 5.4997 4.03848 7.3913 3.89298L51.0952 0.531135V0H4Z",
    fill: "#969592"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250 66C252.209 66 254 64.2091 254 62V41.027H253.165L250.845 59.2006C250.605 61.0825 249.076 62.5368 247.184 62.6823L210 65.5426V66H250ZM210 41.1744C210.035 41.1244 210.071 41.0753 210.108 41.027H210V41.1744Z",
    fill: "#969592"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 65,
    width: 218,
    height: 1,
    fill: "#969592"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4044_29418",
    x: 0,
    y: 0,
    width: 254,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.937255 0 0 0 0 0.901961 0 0 0 0 0.827451 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4044_29418"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteBtn);
export default __webpack_public_path__ + "static/media/white-btn.0563f998942bb82a51065a5d2c7287b5.svg";
export { ForwardRef as ReactComponent };